<template>
    <div class="head-top">
        <div class="column-banner">
            <img src="../../assets/images/yq_bg.jpg" alt="专栏">
        </div>
        <div class="column-nav">
            <div class="n-list">
                <a v-for="(nav,index) in navList" :key="index" :href="nav.link" target="_blank">
                    <p>
                        <img :src="nav.icon" alt="">
                    </p>
                    <p>{{nav.name}}</p>     
                </a>
            </div>
        </div>     
    </div>
</template>

<script>
import icon1 from '../../assets/images/nav_ico_1.png'
import icon2 from '../../assets/images/nav_ico_2.png'
import icon3 from '../../assets/images/nav_ico_3.png'
import icon4 from '../../assets/images/nav_ico_4.png'

export default{
    name: 'headTop',
    data(){
        return{
            navList:[
                {link: 'https://v.gxnews.com.cn/sp/19274604', name: '快捷服务', icon: icon1},
                {link: 'https://v.gxnews.com.cn/?c=zt&zt=2020zgzs&from=timeline&isappinstalled=0', name: '正声辟谣', icon: icon2},
                {link: 'https://v.gxnews.com.cn/zt/2020yq', name: '疫情数据', icon: icon3},
                {link: 'https://v.gxnews.com.cn/sp/19258958?from=timeline&isappinstalled=0', name: '各地门诊', icon: icon4}
            ]
        }
    }
}
</script>

<style lang="less" scoped>
    .column-banner{
        position: relative;
        z-index: 5;
        img{
            width: 100%;
        }
    }
    .column-nav{
        padding: 0 0.3rem;
        margin-top: -2.3rem;
        position: relative;
        z-index: 10;
    }
    .n-list{
        padding: 0.3rem 0;
        background: #fff;
        border-radius: 0.2rem;
        overflow: hidden;
        box-shadow: 0 0 0.2rem #f0f0f0;
        a{
            display: block;
            float: left;
            width: 25%;
            text-align: center;
            color: #333;
            font-size: 0.38rem;
        }
        p{
            &:nth-of-type(1){
                margin-bottom: 0.15rem;
            }
        }
        img{
            width: 42%;
        }
    }
</style>   